module.exports = __webpack_public_path__ + "static/media/first.ffccfab1.gif";